import { SparklesIcon } from "lucide-react";

interface AIInsightCardProps {
  text: string;
}

export function AIInsightCard({ text }: AIInsightCardProps) {
  return (
    <div className="border border-[#5E548E]/50 bg-[#5E548E]/10 rounded-[10px] p-4">
      <div className="flex flex-row items-start gap-x-4">
        {/* Sparkles */}
        <div className="shrink-0 h-10 w-10 rounded-[10px] border border-[#5E548E]/50 bg-[#5E548E]/20 flex justify-center items-center">
          <SparklesIcon
            strokeWidth={1.5}
            className="text-[#5E548E]"
          />
        </div>
        {/* Copy */}
        <div className="flex flex-col gap-y-1">
          <p className="font-bold font-display uppercase text-sm text-[#5E548E]">
            Insight
          </p>
          <p className="text-sm">
            {text}
          </p>
        </div>
      </div>
    </div>
  );
}
